import { ActivityType } from "PFApp/components/card_tx/header/activity_type_badge";
import { Card } from "PFComponents/card";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { Activity } from "PFTypes";

import { CardTxContent } from "./card_tx_content";

export type CardTxProps = {
  activity: Activity;
  numberOfRoles?: number;
  isHotVisible?: boolean;
  isFeed?: boolean;
  handleEditPost?: (activityId: number) => void;
  handleHeaderClick?: () => void;
  onShare?: (id: number) => void;
  handleRefetchActivities?: () => void;
};

export const CardTx = ({
  activity,
  numberOfRoles,
  isHotVisible,
  isFeed,
  handleEditPost,
  handleHeaderClick,
  onShare,
  handleRefetchActivities
}: CardTxProps) => {
  const {
    data: { templates }
  } = useMyAccountInfo();

  const type: ActivityType = (templates || []).find(({ id }) => id === activity.template_id) || {
    key: "default"
  };

  const isDraft = activity.state === "draft";
  const canShare =
    activity.state !== "draft" && ((activity.coowned && activity.private) || !activity.private);
  const handleShare = canShare ? onShare : undefined;
  const interestedIn = activity.statistics.watchers_count;

  return (
    <Card>
      <CardTxContent
        activity={activity}
        type={type}
        isDraft={isDraft}
        isFeed={isFeed}
        numberOfRoles={numberOfRoles}
        isHotVisible={isHotVisible}
        interestedIn={interestedIn}
        handleShare={handleShare}
        handleEditPost={handleEditPost}
        handleHeaderClick={handleHeaderClick}
        handleRefetchActivities={handleRefetchActivities}
      />
    </Card>
  );
};
